<template>
    <span
        v-show="discountPercentage(product)"
        class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
    >
        {{ discountPercentage(product) }}
    </span>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Productoffer",
    /* eslint-enable */
    props: {
        product: {
            required: true
        }
    },
    methods: {
        discountPercentage(product) {
            let promotional_values = product.NewProductDiscount;
            if (!promotional_values) {
                return;
            }
            let today = new Date();
            let enddate = new Date(promotional_values.end_date);
            let startdate = new Date(promotional_values.start_date);
            let returnvalue = "";
            if (enddate >= today && startdate <= today) {
                if (promotional_values.discount_value) {
                    returnvalue = Number(
                        promotional_values.discount_value
                    ).toFixed(2);
                }
                if (promotional_values.discount_type == "Flat") {
                    returnvalue = "-$" + returnvalue;
                } else {
                    returnvalue = "-" + returnvalue + "%";
                }
            }
            return returnvalue;
        }
    }
};
</script>
